// src/api/notifications/communicationsFeedApi.ts

import { ENV } from '../../config/runtimeEnv';
import type { CommunicationsFeedFilters, CommunicationsFeedResponse } from '../../types/communications/CommunicationFeedTypes';
import { createServiceClient } from '../../lib/http/client';

export const COMMUNICATIONS_API_BASE_URL = ENV.VITE_NOTIFICATION_BASE_URL;

const createApiInstance = () => {
	return createServiceClient({
		baseURL: COMMUNICATIONS_API_BASE_URL,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

/**
 * One page of the clinic-wide feed.
 *
 * Empty-string filters are stripped rather than sent: the controller treats `?search=` as a
 * present-but-empty filter, which is not the same thing as "no filter".
 */
export const fetchCommunicationsFeed = async (
	filters: CommunicationsFeedFilters = {},
): Promise<CommunicationsFeedResponse> => {
	const params = Object.fromEntries(
		Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== ''),
	);

	const api = createApiInstance();
	const response = await api.get<CommunicationsFeedResponse>('/communications/feed', { params });

	return response.data;
};
